export enum UserRole {
    ADMIN = 'ADMIN',
    USER = 'USER',
    WORKER = 'WORKER'
  }

  export const FileTypes = {
    image: "image",
    document: 'document'
}

// For USERS (job creators)
export const JobStatusButtonText_User: Record<string, string> = {
  pending: "pending",
  awaiting_payment: "payNow",
  confirmed: "workersConfirmationPending",
  worker_on_way: "workerIsOnTheWay",
  reached: "CompleteJob",
  in_progress: "CompleteJob",
  job_finished: "releaseFunds",
  completed: "releaseFunds",
  successfully_completed: "jobCompleted",
  cancelled: "jobCancelled",
  rejected: "jobRejected",
  refunded: "refunded",
};

export const JobStatusDetailStatus: Record<string, string> = {
  pending: "pending",
  awaiting_payment: "awaitingPayment",
  confirmed: "confirmStatus",
  worker_on_way: "workerIsOnTheWay",
  reached: "reached",
  in_progress: "inProgress",
  job_finished: "jobFinished",
  completed: "jobFinished",
  successfully_completed: "successfullyCompleted",
  cancelled: "cancelled",
  rejected: "jobRejected",
  refunded: "refunded",
  dispute: "reportIt",
  CompleteJob:"Complete"
};

// For WORKERS
export const JobStatusButtonText_Worker: Record<string, string> = {
  pending: "acceptReject",
  accepted: "confirmJob",
  confirmed: "markOnMyWay",
  on_my_way: "markAsReached",
  reached: "startJob",
  in_progress: "finishJob",
  job_finished: "submitForCompletion",
  successfully_completed: "jobCompleted",
  cancelled: "jobCancelled",
  rejected: "applicationRejected",
  withdrawn: "applicationWithdrawn",
  refunded: "refunded",
};

export const AvailabilityOptions = {
  mondayToFriday : 'Monday to Friday',
  saturdayToSunday : 'Saturday to Sunday',
  allDays : 'Every day'
}
// 
// 
// 